import Api from '@api';
import {getFormConfig} from "../../configs/headFormConfig";
import {getTableColumn} from '../../configs/headTableConfig';
import {getSearchValueList,keyToConfigList, uniqueArr, isCanShowBlock} from '@utils'
import { HEAD_FOOT_CODE,TABLE_COLUMN_COMMON } from '@constant'
import habitMixins from '@/mixins/habit.js';
import formTableInitMixins from '@/mixins/formTableInit.js';
import exportEdit from '@/mixins/exportEdit.js';

export default {
  name: 'headCom',
  components:{  },
  mixins: [habitMixins,formTableInitMixins, exportEdit],
  provide() {
    return {
      getTableList: this.getList
    };
  },
  data: function () {
    const dataTableName = "PRE_ADVICE HEADER";
    const formConfig = getFormConfig(this).filterFormConfig.filter(item => (item.label && isCanShowBlock('searchInfo', item.showBlock)));
    const tableColumn = getTableColumn(this).tableColumn;
    const tableColumnSearchKey = HEAD_FOOT_CODE.headCode

    const ALL_SEARCH_ITEM_LIST = JSON.parse(window.sessionStorage.getItem('ALL_SEARCH_ITEM_LIST'))[dataTableName];
    const ALL_TABLE_COLUMNS = JSON.parse(window.sessionStorage.getItem('ALL_TABLE_COLUMNS'))[dataTableName];

    const filterFormConfig = keyToConfigList(ALL_SEARCH_ITEM_LIST, formConfig)
    const tableColumnConfigList = keyToConfigList(ALL_TABLE_COLUMNS, tableColumn, 'tag')

    return {
      formData: {}, //筛选条件
      filterFormConfig,
      conditions: formConfig, // 增加查询条件的值
      importData: [], // table 数据
      tableColumnSearchKey,
      tableColumn, // 原本的表格配置
      tableColumnConfigList,
      headerDataTable:'PRE_ADVICE HEADER',
      lineDataTable:'PREVICE LINE',
      dataTableName,
      injectData: {},
      dialog:'',
      checkedList:[],
      selectionList: [],
      rangeSelectionList: [],
      initFormData:{},
      searchItemList: ALL_SEARCH_ITEM_LIST,
      tableColumnList: ALL_TABLE_COLUMNS
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.$store.commit('SET_CURRENT_HEADERS',{model:'preAdvice',header:[]})
      // this.getList();
    })
  },
  watch:{
    tableColumnConfigList(){
      this.dropColumn = this.tableColumnConfigList;
    },
  },
  methods: {
    getLineList(){
      let ORDER_LIST = this.checkedList.map(item=>item.PRE_ADVICE_ID)
      this.$store.commit('SET_CURRENT_HEADERS',{model:'preAdvice',header:ORDER_LIST})
      this.$store.commit('SET_CURRENT_TAB',{model:'preAdvice',currentTab:'lineCom'})
    },
    /**
     * @description 获取列表数据
     */
    async getList(){
      let CRITERION_LIST = getSearchValueList(this.conditions, this.$refs.filterForm.formData)
      let SHOW_COLUMN_LIST = this.tableColumnConfigList.map(item => item.tag).filter(item=>!TABLE_COLUMN_COMMON.includes(item))
      let EXTRA_COLUMN = ['PRE_ADVICE_ID','CLIENT_ID']
      let params = {
        CRITERION_LIST: CRITERION_LIST,
        SHOW_COLUMN_LIST: uniqueArr([...SHOW_COLUMN_LIST,...EXTRA_COLUMN]),
        PAGE_NUM: this.$refs.configTable.page.currentPage,
        PAGE_SIZE: this.$refs.configTable.page.pageSize
      };
      this.exportParams = params;
      const {status,data,message} = await Api.GetPreadviceHeaderList(params)
      this.initFormData = this.$refs.filterForm.formData;
      if(status === 200){
        this.importData = data.list
        this.$refs.configTable.page.total = Number(data.total)
      }
    },
    /**
     * @description 表单编辑时候的跳转
     */
    clientEdit({PRE_ADVICE_ID,CLIENT_ID,LINE_ID}, type) {
      this.dialog = type;
      this.$router.push({
        path:'/preAdviceHeadDetail',
        query:{
          PRE_ADVICE_ID,
          CLIENT_ID,
          LINE_ID,
          _current:this.dataTableName
        }
      })
    },
    /**
     * @description 清除表单和父子间的数据
     */
    dialogClosed(){
      this.dialog = null;
      this.injectData = {};
    },
    /**
     * @description 导出
     */
    handleExport() {
      this.exportDefine('PreAdvice-Header 表', 'ExportPreAdviceHeader');
    },
  }
}